import { forwardRef, useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import dateFormat from 'dateformat';

import styles from '@containers/Dashboard/Dashboard.module.scss';

import {
  CollapseBackorder,
  CollapseDocuments,
} from '@components/Dashboard/ActionItems/Collapse';
import { BootstrapTable } from '@components/Table';
import { BACKORDER, ORDER } from '@config/const';

const renderCollapseButton = ({ row, ref }) => {
  const { type, uuid } = row.original;
  if (type === ORDER) {
    return row.original.documents?.length > 0 ? (
      <CollapseDocuments data={row.original.documents} uuid={uuid} ref={ref} />
    ) : null;
  }
  if (type === BACKORDER) {
    return row.original.didorders?.length > 0 ? (
      <CollapseBackorder data={row.original.didorders} />
    ) : null;
  }
  return null;
};

const renderReferenceNumberCell = ({ row, value, ref }) => {
  const { type, uuid } = row.original;
  const detailsURL = `/order/open/${uuid}/details`;
  return (
    <Row>
      <Col>
        <span style={{ textTransform: 'capitalize' }}>{type}</span>{' '}
        <Link className="text-decoration-none" to={detailsURL}>
          {value}
        </Link>
      </Col>
      {renderCollapseButton({ row, ref })}
    </Row>
  );
};

const renderOrderDate = ({ value }) => {
  const date = new Date(value);
  const formattedDate = dateFormat(date, 'd mmm yyyy');
  const formattedTime = dateFormat(date, 'shortTime');
  return (
    <div className={styles.dashboardDate}>
      {formattedDate}
      <span>{formattedTime}</span>
    </div>
  );
};

export const OpenOrderTable = forwardRef(({ data }, ref) => {
  const columns = useMemo(
    () => [
      {
        accessor: 'order_date',
        className: 'col-md-2',
        Cell: renderOrderDate,
      },
      {
        accessor: 'reference_number',
        className: 'col-md-9',
        Cell: ({ row, value }) =>
          renderReferenceNumberCell({ row, value, ref }),
      },
    ],
    []
  );

  return (
    <BootstrapTable
      columns={columns}
      data={data}
      tableProps={() => ({ borderless: true })}
      hideHeader
    />
  );
});
